import { useQuery } from "react-query";
import { CommApiInstance} from "Utils/CommApiInstance";
import MgpStore from "Stores/Store";

import GameSvcLstDataType from "Interface/Apis/GameSvcLst.Interface";
import { useSelector } from "react-redux";


const GameSvcLstInqApi = async () => {

    return await CommApiInstance.post(`comm/game/game_lst`,{
        apiBody:"",
    },
    )
    .then((Resp) => Resp.data.apiBody);
}
const UseGameSvcLstQuery = () => {
    // useSelector로 실시간 상태 구독
    const currentLang = useSelector((state: any) => state.LangSetState.Lang);
    
    
    return useQuery<GameSvcLstDataType[]>({
        queryKey: ["GameSvcLstRendering", currentLang],
        queryFn:GameSvcLstInqApi,
        refetchOnReconnect:false,
        refetchOnMount:true,
        staleTime: 0, // 캐시 비활성화로 테스트
        cacheTime: 0, // 캐시 비활성화로 테스트
    })
}

export default UseGameSvcLstQuery;